<template>
  <FormDropdown
    v-if="options && options.length"
    tag="span"
    :removeDropdownTottle="true"
    :alignRight="true"
  >
    <button
      v-for="link in options"
      class="dropdown-item"
      :id="link.id"
      :key="link.id"
      @click="link.click"
    >
      <i :class="link.icon"></i>
      {{ link.name }}
    </button>

    <template #title>
      <svg
        class="text-dark table-element-item-dropdown"
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 20 20"
        fill="currentColor"
        :id="`table-element-item-dropdown-${item.uid}`"
      >
        <path
          d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
        />
      </svg>
    </template>
  </FormDropdown>
  <div v-else></div>
</template>

<script>
import FormDropdown from "/src/components/FormDropdown.vue";

export default {
  components: {
    FormDropdown,
  },
  props: {
    item: {
      type: [Object, String],
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style>
.dropdown-item {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
</style>
